import { render, staticRenderFns } from "./TreatmentOptions.vue?vue&type=template&id=988834b2"
import script from "./TreatmentOptions.vue?vue&type=script&lang=js"
export * from "./TreatmentOptions.vue?vue&type=script&lang=js"
import style0 from "./TreatmentOptions.vue?vue&type=style&index=0&id=988834b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports